import Col from "@visa/vds/col";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import MCSReadonlyField from "components/MCSReadonlyField";
import React from "react";

const PaymentInformation = (props) => {
  return (
    <>
      <Row>
        <Col>
          <Typography tag="h2">Payment Info</Typography>

          {props.organizationData && !props.organizationData.isUVID && (
            <MCSReadonlyField label="Payment Method" text="Bill to Visa BID" />
          )}
          {props.organizationData && props.organizationData.isUVID && (
            <MCSReadonlyField
              label="Payment Method"
              text="Pay by Credit Card"
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default PaymentInformation;
